/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e="esri-building-phase-picker",r={base:`${e}`,phasesContainer:`${e}__phases-container`,phase:`${e}__phase`,phaseActive:`${e}__phase--active`,phaseCurrent:`${e}__phase--current`,divider:`${e}__divider`,dividerActive:`${e}__divider--active`,arrowLeft:`${e}__arrow-left`,arrowRight:`${e}__arrow-right`};export{r as css};
